import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Technologysec(props) {
  const [activeTab, setActiveTab] = useState(1);

  function displayTab(tabNumber) {
    setActiveTab(tabNumber);
  }

  return (
    <>
      <div className="tekgriping_section p-100">
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={7} lg={7} xl={7} xxl={6} className="my-auto">
              <div className="example" data-text="Our Forte">
                <h2>Our Services</h2>
              </div>
              <p>
                Our team is committed to developing flexible and scalable cloud
                solutions that will enable companies to prosper in the rapidly
                evolving digital industry. We provide modern cloud computing
                services to companies looking to reduce costs and increase
                productivity.
              </p>
            </Col>
            <Col xs={12} md={5} lg={5} xl={5} xxl={6} className="my-auto">
              <div className="tekgrip_flex">
                <div className="tekgrip_title">
                  <h5>
                    2X
                    <span>Increase in ROI</span>
                  </h5>
                </div>
                <div className="tekgrip_title">
                  <h5>
                    60%
                    <span>Increase in Efficiency</span>
                  </h5>
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
              <h3
                onClick={() => {
                  displayTab(1);
                }}
                className={`tabs ${activeTab === 1 ? "active" : ""}`}
              >
                <div className="tab_namee">Infrastructure Management</div>
              </h3>

              <h3
                onClick={() => {
                  displayTab(2);
                }}
                className={`tabs ${activeTab === 2 ? "active" : ""}`}
              >
                <div className="tab_namee">Data Management</div>
              </h3>

              <h3
                onClick={() => {
                  displayTab(3);
                }}
                className={`tabs ${activeTab === 3 ? "active" : ""}`}
              >
                <div className="tab_namee">Application Management</div>
              </h3>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="tekgrip_tabs_iamge tekrevol_dark_bg p-100">
        <Container className="h-100">
          <Row className={activeTab === 1 ? "d-flex h-100" : "d-none h-100"}>
            <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_content">
                <h2>Infrastructure Management</h2>
                <p>
                  Infrastructure management comprises of building and
                  configuration of cloud infrastructure elements e.g. networks,
                  servers, storage, and virtualization, as well as continual
                  maintenance. We focus on streamlining the procedures,
                  increasing cost efficiency, and offering users a seamless
                  experience so that organizations can be able to adapt to the
                  evolving cloud environment.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_image ">
                <StaticImage
                  src="../../images/services/managed-clouds/infrastructure_img.webp"
                  alt="TekRevol"
                  className="slide-top"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={646}
                  height={841}
                />
              </div>
            </Col>
          </Row>
          <Row className={activeTab === 2 ? "d-flex h-100" : "d-none h-100"}>
            <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_content">
                <h2>Data Management</h2>
                <p>
                  Cloud data management refers to a range of procedures and
                  methods for managing, organizing, safeguarding, and maximizing
                  data kept in cloud settings. To guarantee data integrity,
                  security, and accessibility, our specialists use the latest
                  techniques and cutting-edge technology, allowing companies to
                  fully utilize their data assets.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_image">
                <StaticImage
                  src="../../images/services/managed-clouds/data_img.webp"
                  alt="TekRevol"
                  className="slide-top"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={646}
                  height={841}
                />
              </div>
            </Col>
          </Row>
          <Row className={activeTab === 3 ? "d-flex h-100" : "d-none h-100"}>
            <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_content">
                <h2>Application Management</h2>
                <p>
                  Application management is the process of keeping track of,
                  maintaining, and optimizing cloud-based applications. From
                  dependability to safety to performance, we provide the
                  complete spectrum of application management, which includes
                  continuous monitoring, proactive maintenance, and precise
                  optimization strategies.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_image ">
                <StaticImage
                  src="../../images/services/managed-clouds/app_manage_img.webp"
                  alt="TekRevol"
                  className="slide-top"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={646}
                  height={841}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Technologysec;
